import api from './axios';

export const fetchEmployeeAttendance = async (employeeId, month, year) => {
    return api.get(`/attendance/employee/${employeeId}`, {
        params: { month, year }
    });
}

export const fetchAllAttendanceForDate = async (date) => {
    return api.get('/attendance/all', {
        params: { date }
    });
}

export const fetchAttendanceSummary = async ({ from_date, to_date, employee_ids, designation }) => {
    return api.get('/attendance/summary', {
        params: {
            from_date,
            to_date,
            employee_ids: employee_ids && employee_ids.length > 0 ? employee_ids.join(',') : undefined,
            designation: designation || undefined,
        }
    });
}

export const exportAttendanceSummary = async ({ from_date, to_date, employee_ids, designation }) => {
    return api.get('/attendance/summary', {
        params: {
            from_date,
            to_date,
            employee_ids: employee_ids && employee_ids.length > 0 ? employee_ids.join(',') : undefined,
            designation: designation || undefined,
            export: true,
        },
        responseType: 'blob',
    });
}

export const createAttendance = async (attendanceData) => {
    return api.post('/attendance', attendanceData);
}

export const updateAttendance = async (id, attendanceData) => {
    return api.put(`/attendance/${id}`, attendanceData);
}

export const deleteAttendance = async (id) => {
    return api.delete(`/attendance/${id}`);
}

export const fetchEmployeeLocations = async (employeeId, date) => {
    return api.get(`/locations/employee/${employeeId}`, {
        params: { date }
    });
}

export const fetchAllLatestLocations = async () => {
    return api.get('/locations/latest');
}
